const l10n:FooterL10n =  {
  "linkList": {
    "companyLink": "Giới thiệu công ty",
    "termsOfService": "Điều khoản sử dụng",
    "privacyPolicy": "Chính sách bảo mật",
    "guaranteeOfRights": "Bảo đảm quyền lợi của chủ thể thông tin",
    "customerSupport": "Hỗ trợ khách hàng",
    "cookiePolicy": "Chính sách cookie",
    "declarationOfSafety": "An toàn & Tuyên bố an toàn",
    "youthProtectionPolicy": "Chính sách bảo vệ thanh thiếu niên",
    "communityPolicy": "Thông tin xác suất/chính sách cộng đồng",
    "probability": "",
    "operationPolicy": "Chính sách hoạt động",
    "doNotSell": "Không bán thông tin cá nhân của tôi",
    "gameGrade": "Mức độ sử dụng trò chơi",
    "communityPolicyView": "Chính sách cộng đồng",
    "servicePolicy": "Chính sách dịch vụ",
    "termsOfUse": "Chính sách thành viên",
    "operationPolicyNCJ": "Chính sách hoạt động",
    "reportRightsInfringement": "Báo cáo vi phạm quyền lợi",
    "ncPrivacyCenter": "Trung tâm bảo mật NC",
    "commercialTransactions": "Chú giải theo Đạo luật giao dịch cụ thể",
    "settlementFund": "Chú giải theo Đạo luật giải quyết quỹ",
    "serviceTerm": "Điều khoản dịch vụ",
    "legalDocumentation": "Tài liệu pháp lý",
    "googleAPIDisclosure": "Tiết lộ API của Google",
    "report": "Báo cáo",
    "serviceConsent": "Thỏa thuận dịch vụ NCSOFT",
    "careers": "Careers",
    "termsOfMobile": "Điều khoản và Điều kiện của trò chơi mobile"
  },
  "footerWords": {
    "gameRelatedLaw": "Chú giải bổ sung theo luật liên quan đến trò chơi",
    "brandInformation": "Thông tin tương hỗ",
    "copyright": "Bản quyền",
    "channelingInfo": "NCSOFT là một trung gian đặt hàng qua thư cung cấp các trò chơi hợp tác phát triển cộng đồng trong PLAYNC và không phải là một bên tham gia bán hàng qua thư.<br> Tất cả các nghĩa vụ và trách nhiệm liên quan đến việc cung cấp trò chơi hợp tác phát triển cộng đồng thuộc về cá nhân nhà bán lẻ đặt hàng qua thư và chúng tôi không chịu trách nhiệm về bất kỳ vấn đề nào phát sinh liên quan đến vấn đề này."
  },
  "infoCS": {
    "businessInformation": "Kiểm tra thông tin doanh nghiệp",
    "infoAddress": "NCSOFT Đồng CEO Kim Taekjin, Park Byeongmu Số đăng ký kinh doanh 144-85-04244 Báo cáo kinh doanh đặt hàng qua thư số 2013-Gyeonggi Seongnam-1268",
    "infoAddressNCV": "9 RAFFLES PLACE #26-01 REPUBLIC PLAZA SINGAPORE (048619)",
    "mobile": "Địa chỉ 12 Daewangpangyo-ro 644beon-gil, Bundang-gu, Seongnam-si, Kyunggi-do Dịch vụ khách hàng 1566-7004 Fax 02-2186-3499",
    "pc": "Địa chỉ 12 Daewangpangyo-ro 644beon-gil, Bundang-gu, Seongnam-si, Kyunggi-do Dịch vụ khách hàng 1600-0020 Fax 02-2186-3550",
    "other": "Địa chỉ 12 Daewangpangyo-ro 644beon-gil, Bundang-gu, Seongnam-si, Kyunggi-do Dịch vụ khách hàng 1600-0020 (Game PC), 1566-7004 (Game mobile) Fax 02-2186-3550 (Game PC), 02- 2186-3499 (Game mobile)",
    "none": "",
    "infoEmail": "E-mail",
    "infoEmail-mobile": "MobileCS@ncsoft.com",
    "infoEmail-pc": "credit@ncsoft.com",
    "infoEmail-other": "credit@ncsoft.com/(game PC)/MobileCS@ncsoft.com/(game mobile)",
    "infoEmail-none": ""
  },
  "infoJP": {
    "jpTitle": "Tiêu đề",
    "jpGenre": "Thể loại",
    "jpPrice": "Giá",
    "jpPriceValue": "Miễn phí (bao gồm các sản phẩm mua trong ứng dụng)",
    "jpOs": "Hệ điều hành hỗ trợ",
    "jpDevelopedBy": "Trang Phát triển/Vận hành",
    "jpReleaseDay": "Ngày phát hành",
    "jpReleaseDayValue_LW": "2021.11.4"
  },
  "country": {
    "KR": "Hàn Quốc",
    "TW": "Đài Loan",
    "RU": "Nga",
    "MY": "Malaysia",
    "SA": "Ả Rập Xê Út",
    "SG": "Singapore",
    "AE": "UAE",
    "ID": "Indonesia",
    "JP": "Nhật bản",
    "QA": "Qatar",
    "TH": "Thái Lan",
    "PH": "Philippines",
    "HK": "Hồng Kông",
    "UA": "Ukraina",
    "BY": "Belarus",
    "LT": "Litva",
    "PL": "Ba Lan",
    "GR": "Hy Lạp",
    "IL": "Israel",
    "KW": "Kuwait",
    "AT": "Áo",
    "US": "Mỹ",
    "CA": "Canada",
    "DE": "Đức",
    "GB": "Anh",
    "FR": "Pháp",
    "BR": "Brazil",
    "IT": "Ý",
    "ES": "Tây Ban Nha",
    "CL": "Chilê",
    "NO": "Na Uy",
    "SE": "Thụy Điển",
    "IE": "Ireland",
    "PT": "Bồ Đào Nha",
    "FI": "Phần Lan",
    "DK": "Đan Mạch",
    "CH": "Thụy Sĩ",
    "AR": "Argentina",
    "PE": "Peru",
    "MX": "Mexico",
    "KZ": "Kazakhstan",
    "UZ": "Uzbekistan",
    "AZ": "Azerbaijan",
    "GE": "Gruzia",
    "MD": "Moldova",
    "AM": "Armenia",
    "MO": "Ma Cao",
    "IN": "Ấn Độ",
    "PK": "Pakistan",
    "NL": "Hà Lan",
    "RO": "Rumani",
    "AU": "Úc",
    "TR": "Thổ Nhĩ Kỳ",
    "EC": "Ecuador",
    "CO": "Colombia",
    "ZA": "Nam Phi",
    "EG": "Ai Cập",
    "NC": "Toàn cầu"
  }
};

export default l10n;
